var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ede9e4;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.77,77.3c-.6,10.53,5.17,19.43,13.23,21.8v-21.81h-13.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.07,74.25h12.93v-18.46c-.64-.18-1.32-.27-2.05-.28-6.51.13-10.39,7.94-10.88,18.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.74,0H25.26C11.31,0,0,11.31,0,25.26v93.47c0,13.95,11.31,25.26,25.26,25.26h93.47c13.95,0,25.26-11.31,25.26-25.26v-6.56c-.82.08-1.67.12-2.53.12-15.46,0-24.16-12.88-24.54-28.99-.01-.62,0-1.24,0-1.86,0-.38.02-.77.04-1.15,0-.2.02-.39.03-.61.02-.21.03-.43.05-.64.56-7.11,2.85-13.45,6.63-18.13,2.35-2.91,5.17-5.12,8.37-6.6,2.81-1.42,6.76-2.2,9.98-2.2h.14c.61,0,1.22.02,1.82.06v-26.93c0-13.95-11.31-25.26-25.26-25.26ZM117.69,34.38l-.11.02c-4.23.96-6.38,2.38-6.38,7.52h-.02l.02,61.65c.36,4.06,2.54,5.31,6.38,6.18l.11.03v.87h-29.53v-.87l.11-.03c3.83-.87,5.96-2.12,6.33-6.18v-59.97l-28.47,66.91h-1.57l-27.66-65.09v56.67c0,5.14,2.15,6.56,6.38,7.52l.11.02v.88h-16.96v-.88l.11-.03c4.23-.96,6.39-2.38,6.39-7.52v-60.16c0-5.14-2.15-6.56-6.38-7.52l-.11-.02v-.88h24.99l21.53,50.61,21.53-50.61h23.19v.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
export default __webpack_public_path__ + "static/media/icon-medium.fe3205701228a405ee6c07146f9b463b.svg";
export { ForwardRef as ReactComponent };